import { useNavigate } from 'react-router-dom';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { instance } from './axiosInstance';
import { LOGIN_PATH } from 'constants/path';
import HackleManager from './hackle';
import { STORAGE_KEY } from './localStoarge';
import { callWebviewHandler, isWebview, WebviewOperatorType } from './webview';

export const signoutHook = () => {
  const { clearUserInfo } = useUserInformation(state => state);
  const navigate = useNavigate();

  const handleSignout = async () => {
    try {
      window.handleOpenLoading();

      const response = await instance.post('/users/signout');

      if (response) {
        clearUserInfo();

        HackleManager.logSignoutComplete();
        HackleManager.userLogout();

        window.handleCloseLoading();
        if (isWebview()) {
          localStorage.removeItem(STORAGE_KEY.IS_HOST_ADMIN_APP);
          callWebviewHandler(WebviewOperatorType.LogoutHandler);

          return;
        }
        navigate(LOGIN_PATH);
      }
    } catch (error) {
      window.showToast(error.response.data.message, 'failed');
    }
  };

  return {
    handleSignout,
  };
};
